import React, { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    ChartDataLabels
);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        plugin1: false,
        plugin2: false,
        legend: {
            display: false
        },
        title: {
            display: false,
        },
        tooltip: {
            displayColors: false, 
            callbacks: {
                title: ()=>{
                    return ""
                  },
              // 툴팁에 표시될 내용을 커스터마이징
              label: (context) => {
                const {datasetIndex} = context;
      
                // 첫 번째와 두 번째 데이터를 구분하여 scaleExp 값을 가져옴
                const dataset = context.chart.data.datasets[datasetIndex];
                // scaleExp를 직접 반환하도록 설정
                if (dataset.label === '우울') {
                    if(dataset.data[0]<=8) return "정상";
                    else if(dataset.data[0]<=12) return "경계선 ~ 상담 필요";
                    else return "산후우울증 의심";
                } else if (dataset.label === '불안') {
                    if(dataset.data[0]<=4) return "정상";
                    else if(dataset.data[0]<=9) return "가벼운 수준의 불안";
                    else if(dataset.data[0]<=14) return "중간 수준의 불안";
                    else return "심한 수준의 불안";
                } else {
                  return '';
                }
              }
            }
          },
          datalabels: {
            anchor: 'end', // 막대 위에 값 표시
            align: 'top',
            formatter: (value) => value, // y축 값 표시
            color: 'black', // 값 색상
          },
    },                
    scales: {
        x: {
            display: true,
            grid: {
              display: false,
            },
            border: {
              display: false
            },
            ticks: {
              color: '#000',
            },
          },
      y: {
        display: false
      }
    },
    barThickness: 10,
    elements: {
      bar: {
        borderRadius: 10, // 모서리를 둥글게
      }
    },
    layout: {
        padding : {
          top: 25,
        }
      }
  };

function SurveyBarChart({firstData, secondData}) {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        if(firstData.length>0 || secondData.length>0){
            // x축(sessionNum) 값 설정
            const sessionNums = [...new Set([...firstData.map(item => item.sessionNum), ...secondData.map(item => item.sessionNum)])];

            // 첫 번째 데이터 처리
            const firstDataScores = sessionNums.map(sessionNum => {
                const data = firstData.find(item => item.sessionNum === sessionNum);
                return data ? data.totalScore : 0; // 해당 세션이 없으면 0으로 처리
            });

            // 두 번째 데이터 처리
            const secondDataScores = sessionNums.map(sessionNum => {
                const data = secondData.find(item => item.sessionNum === sessionNum);
                return data ? data.totalScore : 0;
            });

            // Chart.js에서 사용할 데이터 구성
            setChartData({
                labels: sessionNums.map(session=>`${session}주차`),
                datasets: [
                    {
                        label: '우울',
                        data: firstDataScores,
                        backgroundColor: '#76ABFF' // 첫 번째 데이터의 막대 색상
                    },
                    {
                        label: '불안',
                        data: secondDataScores,
                        backgroundColor: '#FF8567' // 두 번째 데이터의 막대 색상
                    }
                ]
            });
        }
    },[firstData, secondData])    

    return (
        chartData ? <Bar options={options} data={chartData} /> : null
    );
}

export default SurveyBarChart;